import { render, staticRenderFns } from "./ModalAdicionarFiscal.vue?vue&type=template&id=4c12d54b&scoped=true"
import script from "./ModalAdicionarFiscal.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarFiscal.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarFiscal.vue?vue&type=style&index=0&id=4c12d54b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12d54b",
  null
  
)

export default component.exports